import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { MicrosoftIntuneConnector } from '../../connector';

export const MicrosoftIntuneService = IntegrationService.make({
  connector: MicrosoftIntuneConnector,
  name: Integration_Service_Names_Enum.MicrosoftIntune,
});
